__turbopack_context__.v({
  "badge": "page-module__Jk0qcq__badge",
  "card": "page-module__Jk0qcq__card",
  "cardHeader": "page-module__Jk0qcq__cardHeader",
  "cardLink": "page-module__Jk0qcq__cardLink",
  "cardSummary": "page-module__Jk0qcq__cardSummary",
  "cardTitle": "page-module__Jk0qcq__cardTitle",
  "controls": "page-module__Jk0qcq__controls",
  "date": "page-module__Jk0qcq__date",
  "empty": "page-module__Jk0qcq__empty",
  "emptyIcon": "page-module__Jk0qcq__emptyIcon",
  "errorMessage": "page-module__Jk0qcq__errorMessage",
  "fadeIn": "page-module__Jk0qcq__fadeIn",
  "form": "page-module__Jk0qcq__form",
  "formActions": "page-module__Jk0qcq__formActions",
  "formGroup": "page-module__Jk0qcq__formGroup",
  "formHeader": "page-module__Jk0qcq__formHeader",
  "formNote": "page-module__Jk0qcq__formNote",
  "formRow": "page-module__Jk0qcq__formRow",
  "formSection": "page-module__Jk0qcq__formSection",
  "grid": "page-module__Jk0qcq__grid",
  "hero": "page-module__Jk0qcq__hero",
  "heroSubtitle": "page-module__Jk0qcq__heroSubtitle",
  "heroTitle": "page-module__Jk0qcq__heroTitle",
  "infoBox": "page-module__Jk0qcq__infoBox",
  "loading": "page-module__Jk0qcq__loading",
  "modalBody": "page-module__Jk0qcq__modalBody",
  "modalClose": "page-module__Jk0qcq__modalClose",
  "modalContent": "page-module__Jk0qcq__modalContent",
  "modalDate": "page-module__Jk0qcq__modalDate",
  "modalFooter": "page-module__Jk0qcq__modalFooter",
  "modalHeader": "page-module__Jk0qcq__modalHeader",
  "modalInstitution": "page-module__Jk0qcq__modalInstitution",
  "modalOverlay": "page-module__Jk0qcq__modalOverlay",
  "modalSection": "page-module__Jk0qcq__modalSection",
  "page": "page-module__Jk0qcq__page",
  "pageIndicator": "page-module__Jk0qcq__pageIndicator",
  "pagination": "page-module__Jk0qcq__pagination",
  "paginationButton": "page-module__Jk0qcq__paginationButton",
  "paginationControls": "page-module__Jk0qcq__paginationControls",
  "paginationCount": "page-module__Jk0qcq__paginationCount",
  "paginationInfo": "page-module__Jk0qcq__paginationInfo",
  "results": "page-module__Jk0qcq__results",
  "searchBar": "page-module__Jk0qcq__searchBar",
  "searchButton": "page-module__Jk0qcq__searchButton",
  "searchInput": "page-module__Jk0qcq__searchInput",
  "showAllActive": "page-module__Jk0qcq__showAllActive",
  "showAllButton": "page-module__Jk0qcq__showAllButton",
  "slideDown": "page-module__Jk0qcq__slideDown",
  "slideUp": "page-module__Jk0qcq__slideUp",
  "spin": "page-module__Jk0qcq__spin",
  "spinner": "page-module__Jk0qcq__spinner",
  "submitButton": "page-module__Jk0qcq__submitButton",
  "successMessage": "page-module__Jk0qcq__successMessage",
});
